import {AssetType} from '../../../constants/securspace-constants';
import {FormConfig} from '../interfaces';

import LoadedContainerForm from './LoadedContainerForm';
import {validateLoadedContainerForm} from './LoadedContainerForm.validation';

import EmptyContainerForm from './EmptyContainerForm';
import {validateEmptyContainerForm} from './EmptyContainerForm.validation';

import ChassisOnlyForm from './ChassisOnlyForm';
import {validateChassisOnlyForm} from './ChassisOnlyForm.validation';

import TrailerLoadedForm from './TrailerLoadedForm';
import {validateTrailerLoadedForm} from './TrailerLoadedForm.validation';

import TrailerEmptyForm from './TrailerEmptyForm';
import {validateTrailerEmptyForm} from './TrailerEmptyForm.validation';

import TruckOnlyForm from './TruckOnlyForm';
import {validateTruckOnlyForm} from './TruckOnlyForm.validation';

/**
 * Registry mapping each AssetType key to its form component and validation function.
 *
 * To add a new asset type:
 * 1. Create `NewAssetForm.tsx` and `NewAssetForm.validation.ts` under `forms/`.
 * 2. Import both here.
 * 3. Add a new entry to this map keyed by the AssetType constant.
 *
 * Multiple asset type keys can alias the same form when they share identical
 * fields and validation (e.g. CONTAINER_LOADED and TRUCK_CONTAINER_LOADED).
 */
export const formRegistry: Record<string, FormConfig> = {
  // ── Loaded Container ────────────────────────────────────────────────────────
  [AssetType.CONTAINER_LOADED]: {component: LoadedContainerForm, validate: validateLoadedContainerForm},
  [AssetType.TRUCK_CONTAINER_LOADED]: {component: LoadedContainerForm, validate: validateLoadedContainerForm},

  // ── Empty Container ─────────────────────────────────────────────────────────
  [AssetType.CONTAINER_EMPTY]: {component: EmptyContainerForm, validate: validateEmptyContainerForm},
  [AssetType.TRUCK_CONTAINER_EMPTY]: {component: EmptyContainerForm, validate: validateEmptyContainerForm},

  // ── Chassis Only ────────────────────────────────────────────────────────────
  [AssetType.CHASSIS_ONLY]: {component: ChassisOnlyForm, validate: validateChassisOnlyForm},

  // ── Trailer Loaded ──────────────────────────────────────────────────────────
  [AssetType.TRUCK_TRAILER_LOADED]: {component: TrailerLoadedForm, validate: validateTrailerLoadedForm},
  [AssetType.TRAILER_LOADED]: {component: TrailerLoadedForm, validate: validateTrailerLoadedForm},
  [AssetType.REEFER_LOADED_PLUGIN]: {component: TrailerLoadedForm, validate: validateTrailerLoadedForm},
  [AssetType.REEFER_LOADED_NO_PLUGIN]: {component: TrailerLoadedForm, validate: validateTrailerLoadedForm},
  [AssetType.TRUCK_REEFER_LOADED_PLUGIN]: {component: TrailerLoadedForm, validate: validateTrailerLoadedForm},
  [AssetType.TRUCK_REEFER_LOADED_NO_PLUGIN]: {component: TrailerLoadedForm, validate: validateTrailerLoadedForm},

  // ── Trailer Empty ───────────────────────────────────────────────────────────
  [AssetType.TRUCK_TRAILER_EMPTY]: {component: TrailerEmptyForm, validate: validateTrailerEmptyForm},
  [AssetType.TRAILER_EMPTY]: {component: TrailerEmptyForm, validate: validateTrailerEmptyForm},

  // ── Truck Only ──────────────────────────────────────────────────────────────
  [AssetType.TRUCK_ONLY]: {component: TruckOnlyForm, validate: validateTruckOnlyForm},
  [AssetType.TRUCK_ONLY_25]: {component: TruckOnlyForm, validate: validateTruckOnlyForm},
};

